export default __webpack_public_path__ + "static/media/Factory02.959687a4.jpg";